module.exports = __webpack_public_path__ + "img/course_001.895fc3f.png";